import { buildSalesRecommendationModalConfig } from "./salesRecommendation/salesRecommendation.modals.builder";
import { buildPurchaseHistoryModalConfig } from "./purchaseHistory/purchaseHistory.modals.builder";
import { buildOrderDetailsUpdatingStates } from "./purchaseHistory/orderDetails.modals.builder";
import { buildOpportunitiesModals } from "./opportunities/opportunities.modals.builder";

const MODAL_BUILDERS = {
  purchaseHistory: buildPurchaseHistoryModalConfig,
  salesRecommendation: buildSalesRecommendationModalConfig,
  orderDetailsUpdatingStates: buildOrderDetailsUpdatingStates,
  opportunities: buildOpportunitiesModals
};

export const buildModalConfig = ({ mode, ...params }) => {
  const builder = MODAL_BUILDERS[mode];
  if (!builder) return null;
  return builder(params);
};

export const renderModal = ({ modalState, components, propsMap }) => {
  return Object.entries(components).map(([key, Component]) => {
    if (modalState[key]) {
      const componentProps = propsMap[key] || {};
      return <Component key={key} {...componentProps} />;
    }
    return null;
  });
};